import React from 'react';
import { generatePath, NavLink, useLocation } from 'react-router-dom';

import { rootRoutes } from '../../../app/routers/rootRoutes';
import { TaskInList } from '../../model/tasks/types';
import styles from './TaskList.module.css';

type Props = {
  values: TaskInList[];
};

export const TaskList: React.FC<Props> = ({ values }) => {
  const location = useLocation();

  return (
    <>
      {values.map((task) => (
        <NavLink
          className={styles.item}
          key={task.id}
          to={generatePath(rootRoutes.task, { taskId: task.id })}
          state={{ goBackTask: location.pathname }}
        >
          <div className={styles.title}>
            <span className={styles.date}>{task.textDate}</span>
            <span className={styles.status}>{task.status}</span>
          </div>
          {task.name}
        </NavLink>
      ))}
    </>
  );
};
